import BlogIndex from "@/views/static/blog/BlogIndex.vue";
import BlogView from "@/views/static/blog/BlogView.vue";
import LastMinuteReiseziel from "@/views/static/blog/posts/last-minute-reiseziel.vue";
import stressfreiesReisen from "@/views/static/blog/posts/stressfreies-reisen.vue";
import staedtetripWellness from "@/views/static/blog/posts/staedtetrip-wellness.vue";
import wanderwegeDeutschland from "@/views/static/blog/posts/wanderwege-deutschland.vue";
import staedtereisenFuerArchitektur from "@/views/static/blog/posts/staedtereisen-fuer-architektur.vue";
import wellnessurlaubJahreszeiten from "@/views/static/blog/posts/wellnessurlaub-jahreszeiten.vue";
import NordseeOstseeVergleich from "@/views/static/blog/posts/nordsee-ostsee-vergleich.vue";
import MaedelsurlaubTippsUndWellness from "@/views/static/blog/posts/maedelsurlaub-tipps-und-wellness.vue";
import DeutschlandStaedtereisenHighlights from "@/views/static/blog/posts/deutschland-staedtereisen-highlights.vue";
import UnentdeckteWellnessoasenDeutschland from "@/views/static/blog/posts/unentdeckte-wellnessoasen-deutschland.vue";

export const useBlogRoutes = () => {
  return [
    {
      path: "/blog",
      component: BlogView,
      children: [
        {
          path: "/",
          name: "touriBlog",
          component: BlogIndex
        },
        {
          path: "last-minute-reiseziele-kurzurlaube-deutschland",
          name: "last-minute-reiseziel",
          component: LastMinuteReiseziel
        },
        {
          path: "so-gelingt-perfekter-kurzurlaub-tipps-stressfreies-reisen",
          name: "stressfreies-reisen",
          component: stressfreiesReisen
        },
        {
          path: "staedtetrip-wellness-kombinieren-schoensten-destinationen",
          name: "staedtetrip-wellness",
          component: staedtetripWellness
        },
        {
          path: "die-schoensten-wanderwege-deutschland",
          name: "wanderwege-deutschland",
          component: wanderwegeDeutschland
        },
        {
          path: "staedtereisen-architektur-designliebhaber",
          name: "staedtereisen-architektur",
          component: staedtereisenFuerArchitektur
        },
        {
          path: "wellnessurlaub-vor-und-nachteile-4-jahreszeiten",
          name: "wellnessurlaub-jahreszeiten",
          component: wellnessurlaubJahreszeiten
        },
        {
          path: "nordsee-ostsee-urlaub-vergleich",
          name: "nordsee-ostsee",
          component: NordseeOstseeVergleich
        },
        {
          path: "der-perfekte-maedelstrip-wellness-entspannung",
          name: "maedelsurlaub-tipps-und-wellness",
          component: MaedelsurlaubTippsUndWellness
        },
        {
          path: "staedetrips-deutschland-diese-staedte-sollte-man-gesehen-haben",
          name: "deutschland-staedtereisen-highlights",
          component: DeutschlandStaedtereisenHighlights
        },
        {
          path: "unentdeckte-wellnessoasen-deutschland",
          name: "unentdeckte-wellnessoasen-deutschland",
          component: UnentdeckteWellnessoasenDeutschland
        }
      ]
    }
  ];
};
